(function()  {

    'use strict';

    const Hotspots = function (element) {

        this.element = element;
        this.spots = element.getElementsByClassName('spot');
        this.description = element.getElementsByClassName('hotspots__description')[0];
        this.breakpoint = matchMedia('(min-width: 64rem)');

        this.evaluateClick = this.evaluateClick.bind(this);
        this.presentDialog = this.presentDialog.bind(this);
        this.dismissDialog = this.dismissDialog.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the event listener.
     */
    Hotspots.prototype.initiateListener = function() {

        for (const spot of this.spots) {

            spot.firstElementChild.addEventListener('pointerdown', this.evaluateClick);
            spot.firstElementChild.addEventListener('keydown', this.evaluateClick);
        }
    }

    /**
     * Evaluates the click first.
     */
    Hotspots.prototype.evaluateClick = function (event) {

        event.stopPropagation();

        if (event.target.getAttribute('aria-expanded') === 'false') {
            this.presentDialog(event);

        } else {
            this.dismissDialog(event);
        }
    }

    /**
     * Presents the dialog.
     */
    Hotspots.prototype.presentDialog = function (event) {

        for (const spot of this.spots) {
            spot.firstElementChild.setAttribute('aria-expanded', 'false');
        }

        event.target.setAttribute('aria-expanded', 'true');

        const sibling = event.target.nextElementSibling;

        const elementBound = this.element.getBoundingClientRect();
        const siblingBound = sibling.getBoundingClientRect();

        const test = siblingBound.width + siblingBound.right;

        if (elementBound.width < test) {
            sibling.classList.remove('container--left');
            sibling.classList.add('container--right')
        }

        this.description.innerHTML = sibling.innerHTML;

        window.addEventListener('pointerdown', this.dismissDialog);
        window.addEventListener('keyup', this.dismissDialog);
    }

    /**
     * Dismisses the dialog.
     */
    Hotspots.prototype.dismissDialog = function (event) {

        let dismiss = false;

        if(event.type === 'pointerdown' && event.target.matches('.spot__trigger')) {
            dismiss = true;
        }

        if (event.type === 'keyup' && event.key === 'Escape' && this.breakpoint.matches) {
            dismiss = true;
        }

        // Dismiss if clicked outside the premise
        if(event.type === 'pointerdown' && !event.target.closest('.spot') && this.breakpoint.matches) {
            dismiss = true;
        }

        // Dismiss if the navigation loses focus
        if (event.type === 'keyup' && !event.target.closest('.spot')) {
            dismiss = true;
        }

        if (dismiss) {
            for (const spot of this.spots) {
                spot.firstElementChild.setAttribute('aria-expanded', 'false');
            }
        }
    }

    const hotspots = document.getElementsByClassName('js-hotspots');

    for (const hotspot of hotspots) {
        new Hotspots(hotspot);
    }
}());